import { z } from 'zod'

export const albumTypedSchema = z.object({
  account_id: z.string({ required_error: 'Account is required' }).uuid('Account is required'),
  label: z
    .string({ required_error: 'Label is required' })
    .min(1, 'Label is required')
    .max(64, 'Label must be 64 characters or less'),
  notes: z.string().max(1024, 'Notes must be 1024 characters or less').nullable().optional(),
  streaming_url: z
    .string()
    .max(255, 'URL must be 255 characters or less')
    .refine((val) => !val || z.string().url().safeParse(val).success, {
      message: 'Invalid URL'
    })
    .nullable()
    .optional()
})

export type AlbumFormValues = z.infer<typeof albumTypedSchema>

export const editAlbumSchema = z.object({
  label: z
    .string({ required_error: 'Label is required' })
    .min(1, 'Label is required')
    .max(64, 'Label must be 64 characters or less'),
  notes: z.string().max(1024, 'Notes must be 1024 characters or less').nullable().optional(),
  streaming_url: z
    .string()
    .max(255, 'URL must be 255 characters or less')
    .refine((val) => !val || z.string().url().safeParse(val).success, {
      message: 'Invalid URL'
    })
    .nullable()
    .optional()
})

export type EditFormValues = z.infer<typeof editAlbumSchema>

export const albumTrackLabelSchema = z.object({
  label: z
    .string({ required_error: 'Label is required' })
    .min(1, 'Label is required')
    .max(64, 'Label must be 64 characters or less')
})

export type AlbumTrackLabelFormValues = z.infer<typeof albumTrackLabelSchema>
